import styled from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';
import { FontFamily } from 'styles/style-variables/font-family';

export const HowItWorks = styled.article`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    padding: 0 16px 16px;
  }
`;

export const HowItWorksDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DescriptionParagraph = styled.p`
  font-family: ${FontFamily.Montserrat};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${EColors.Gray1Text};

  @media (max-width: ${BreakPoint.MobileTop}) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const DescriptionParagraphBold = styled(DescriptionParagraph)`
  font-weight: 600;
`;

export const FAQContentList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FAQTittle = styled.h3`
  font-family: ${FontFamily.Montserrat};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${EColors.Gray1Text};

  @media (max-width: ${BreakPoint.MobileTop}) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export const FAQContentListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FAQContentListItemTitle = styled.h4`
  font-family: ${FontFamily.Montserrat};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: ${EColors.Gray1Text};

  @media (max-width: ${BreakPoint.MobileTop}) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const FAQContentListItemDescription = styled.p`
  font-family: ${FontFamily.Montserrat};
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: ${EColors.Gray1Text};

  @media (max-width: ${BreakPoint.MobileTop}) {
    font-size: 14px;
    line-height: 20px;
  }
`;
